import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'xpHighLight' })
export class XpHighLightPipe implements PipeTransform {
  // eslint-disable-next-line class-methods-use-this
  transform(value: string = '', searchText: string): string {
    if (!searchText) {
      return value;
    }
    return `<span>${(value || '').replace(
      new RegExp(searchText.toLowerCase(), 'i'),
      (val) => `<span class="highlighted-text">${val}</span>`,
    )}</span>`;
  }
}
